<template>
  <!-- 选择人员，查询选择，或根据部门批量选择 -->
  <div v-if="visible">
    <el-dialog v-ismove :visible="true" title="选择人员" :close-on-click-modal="false" :before-close="closeTab" width="1000px">
      <el-row :gutter="20" style="height: 400px">
        <el-col :span="8" style="height: 100%; overflow: auto;">
          <el-row>
            <el-select v-model="name"
              remote
              :remote-method="remoteMethod"
              :loading="loading"
              filterable
              reserve-keyword
              value-key="username"
              size="small"
              placeholder="请输入姓名查询"
              style="margin-bottom:10px"
              @change="changeName">
              <el-option
                v-for="item in userList"
                :key="item.username"
                :label="item.name+'('+item.username+')'"
                :value="item">
              </el-option>
            </el-select>
          </el-row>
          <el-tag
            v-for="(item, index) in selectUser"
            :key="item.username"
            closable
            @close="handleClose(index, item)"
            style="margin: 0px 5px 5px 0">
            {{item.name}}({{item.username}})
          </el-tag>
        </el-col>
        <el-col :span="16">
          <el-row style="border: 1px solid #DCDFE6; border-radius: 4px; height: 400px;">
            <el-col :span="12" style="height: 100%; overflow: auto;">
              <el-tree
                :props="treeProps"
                :data="departTree"
                @node-click="nodeClick">
              </el-tree>
            </el-col>
            <el-col :span="12" style="height: 100%; overflow: auto;">
              <el-table ref="dataTable" :data="checkedList" border @selection-change="selectChange" size="mini" height="398">
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column label="姓名" prop="name" align="center"></el-table-column>
                <el-table-column label="工号" prop="username" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div slot="footer" style="margin-top:2em">
        <el-button size="small" @click="closeTab">取消</el-button>
        <el-button type="primary" size="small" @click="save">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getDDusers, getDepartTree } from '@/api/role'
import { deepClone } from '@/utils/index'

export default {
  name: 'userConf',
  data() {
    return {
      name: null,
      userList: [], // 左侧查询-下拉框
      selectUser: [], // 左侧展示选中人员
      checkedList: [], // 部门下的人员
      needChange: true, // 手动修改选中状态，会触发table选择的change事件，用来阻止此行为
      // checked: [],
      loading: false,
      departTree: [],
      treeProps: {
        label: 'udName',
        children: 'children'
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    allUser: {
      type: Array,
      default: function() {
        return []
      }
    },
    // departTree: {
    //   type: Array,
    //   default: function() {
    //     return []
    //   }
    // },
    hasChoosed: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  watch: {
    'visible'(val) {
      if (val) {
        this.getDepart()
        // this.userList = this.allUser
        console.log(this.allUser)
        console.log(this.departTree)
        console.log(this.hasChoosed)
        this.selectUser = deepClone(this.hasChoosed)
      }
    }
  },
  methods: {
    // 获取部门树形数据
    getDepart() {
      this.departTree = []
      getDepartTree().then(res => {
        if (res.code === '000000') {
          this.departTree = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 根据部门获取人员
    getDepartPerson(id) {
      const _this = this
      getDDusers(id).then(res => {
        if (res.code === '000000') {
          // 处理左侧人员，在右侧表格中选中的效果
          this.checkedList = res.data
          // this.needChange = true
          this.$nextTick(() => {
            this.checkedList.forEach(item => {
              console.log(_this.selectUser)
              const site = this.findInArr(item.username, _this.selectUser)
              if (site !== -1) {
                // 在此修改选中状态会主动触发，selectChange方法，通过标记字段阻止此行为
                this.needChange = false
                this.$refs.dataTable.toggleRowSelection(item, true)
              }
            })
          })
          // 延时将needChange置为true
          setTimeout(() => {
            this.needChange = true
          }, 200)
        }
      }).catch(() => {
        this.checkedList = []
      })
    },
    remoteMethod(val) {
      if (val === '') {
        this.userList = []
      } else {
        this.loading = true
        setTimeout(() => {
          this.userList = this.allUser.filter(item => {
            return item.name.indexOf(val) > -1
          })
          this.loading = false
        }, 200)
      }
    },
    changeName() {
      console.log(this.name)
      let needUpdate = false
      // 查重
      if (this.selectUser.length === 0) {
        this.selectUser.push(this.name)
        needUpdate = true
      } else {
        const find = this.selectUser.filter(item => {
          return item.name === this.name.name && item.username === this.name.username
        })
        if (find.length === 0) {
          this.selectUser.push(this.name)
          needUpdate = true
        }
      }
      // 判断右侧表格是否含有该数据，处理显示
      if (needUpdate) {
        this.checkedList.forEach(el => {
          if (this.name.name === el.name && this.name.username === el.username) {
            this.$refs.dataTable.toggleRowSelection(el, true)
          }
        })
      }
      this.name = null
    },
    selectChange(val) {
      if (!this.needChange) {
        this.needChange = true
        return
      }
      // 处理从选中-到取消的情况，删掉左侧对应数据（checkedList中的数据从左侧删掉）
      this.checkedList.forEach(item => {
        if (val.length > 0) {
          // 选中的值处理左侧选中
          const site = this.findInArr(item.username, val)
          if (site !== -1) {
            val.forEach(el => {
              if (this.findInArr(el.username, this.selectUser) === -1) {
                this.selectUser.push(el)
              }
            })
          } else {
            // 未选中的值处理 取消左侧选中
            const site_c = this.findInArr(item.username, this.selectUser)
            if (site_c !== -1) {
              this.selectUser.splice(site_c, 1)
            }
          }
        } else {
          const site = this.findInArr(item.username, this.selectUser)
          if (site !== -1) {
            this.selectUser.splice(site, 1)
          }
        }
      })
    },
    findInArr(code, arr) {
      let find = -1
      arr.forEach((item, index) => {
        if (code === item.username) {
          find = index
        }
      })
      return find
    },
    handleClose(index, data) {
      // 判断右侧表格是否含有该数据，处理显示
      this.$nextTick(() => {
        this.checkedList.forEach(item => {
          if (data.username === item.username) {
            this.$refs.dataTable.toggleRowSelection(item, false)
          }
        })
      })
      this.selectUser.splice(index, 1)
    },
    nodeClick(val) {
      // 切换部门请求数据，table重置，不应触发change事件; 拿到数据后需要置为true（否则表格渲染完成后，首次点击选中无法触发change事件）
      this.needChange = false
      this.getDepartPerson(val.udId)
    },
    closeTab() {
      this.$emit('update:visible', false)
    },
    save() {
      console.log(this.selectUser)
      this.$emit('save', this.selectUser)
      this.checkedList = []
    }
  }
}
</script>
